import { render, staticRenderFns } from "./ArchiveCandidate.vue?vue&type=template&id=be2c94f4&scoped=true&lang=pug"
import script from "./ArchiveCandidate.vue?vue&type=script&lang=ts"
export * from "./ArchiveCandidate.vue?vue&type=script&lang=ts"
import style0 from "./ArchiveCandidate.vue?vue&type=style&index=0&id=be2c94f4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2c94f4",
  null
  
)

export default component.exports